module.exports = __webpack_public_path__ + "img/KPTCL.edfb9476.png";